module.exports = __webpack_public_path__ + "img/background_img_two.afb33d3a.png";